const navigationBar = {
  titles: {
    assets: "Operaciones",
    area: "Áreas",
    worksModule: "CAO",
    stocks: "Inventario",
    calendar: "Calendario",
    support: "Soporte Técnico",
    userProfile: "Perfil de Usuario"
  },
  area: "Área",
  CAO: "CAO",
  company: "Estructura de la Compañía",
  customer: "Cliente",
  dashboard: "Inicio",
  equipment: "Equipo",
  equipmentType: "Tipo de Equipo",
  hazardous: "Área peligrosa",
  inspectionList: "Inspecciones de Operaciones",
  logs: "Alertas",
  module: "Modulos",
  new: "Nuevo",
  plant: "Planta",
  reliability: "Inspecciones de confiabilidad",
  repairList: "Registro de Reparaciones",
  sealTypes: "Tipo de Sello",
  signOut: "Cerrar Sesión",
  unit: "Unidad",
  user: "Usuario",
  userList: "Lista de Usuarios"
};
export default navigationBar;
